import styled from 'styled-components';

import { colors, fontWeights } from 'theme/theme';

export const Badge = styled.span`
  color: ${colors.white};
  background-color: ${colors.brandBlue};
  border-radius: 4px;
  font-size: 12px;
  font-weight: ${fontWeights.semiBold};
  padding: 2px 6px;
  margin-left: 6px;
`;
